/** action types */
export const FETCH_CATEGORY = 'fetchCategory'
